module.exports = __webpack_public_path__ + "img/angellist.accb76ab.svg";